import templateUrl from './company-edit-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    company: '<',
    onCompanyChanged: '&'
  },
  controller: class CompanyEditFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onCompanyChanged(
        this.EventEmitter({
          company: this.company
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/company/company-edit-form/company-edit-form.component.js